import React, { Component } from 'react';
import PureCanvas from './PureCanvas';

export default class Canvas extends Component {
  constructor(props) {
    super(props);
    this.saveContext = this.saveContext.bind(this);
    this.nextId = 0;
  }

  saveContext(ctx) {
    this.ctx = ctx;
  }

  clearCanvas() {
    const { width, height } = this.props;
    this.ctx.save();
    this.ctx.clearRect(0, 0, width, height);
    this.ctx.restore();
  }

  draw() {
    if (this.ctx) {
      this.clearCanvas();
      if (this.props.items) {
        this.props.items.forEach(item => {
          if (item && typeof item.render === 'function') {
            item.render(this.ctx);
          } else {
            console.log('invalid draw item', item);
          }

        });
      }
    }
  }

  componentDidUpdate() {
    this.draw();
    /*
    const {angle} = this.props;
    const width = this.ctx.canvas.width;
    const height = this.ctx.canvas.height;
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.clearRect(0, 0, width, height);
    this.ctx.translate(width/2, height/2 );
    this.ctx.rotate(angle * Math.PI / 180);
    this.ctx.fillStyle = '#4397AC';
    this.ctx.fillRect(-width/4, -height/4, width/2, height/2);
    this.ctx.restore();
    */
  }

  render() {
    const { width, height } = this.props;
    return <PureCanvas width={width} height={height} contextRef={this.saveContext} ref={c => this._pureCanvas = c}></PureCanvas>;
  }
}
